import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import './custom-file-upload.css';
import { ImageConfig } from './image-config.js';
import CloudUploadOutlined from '@mui/icons-material/CloudUploadOutlined';
import CloudDoneOutlined from '@mui/icons-material/CloudDoneOutlined';
import HelpOutline from '@mui/icons-material/HelpOutline';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';

const FileUpload = (props) => {

  const BrowseButton = styled(Button)(() => ({
    color: '#ffffff',
    fontWeight: 700,
    borderRadius: 8,
    textTransform: 'capitalize',
    background: 'linear-gradient(40deg, #5096FF, #003078)',
    '&:hover': {
      background: 'linear-gradient(45deg, #5096FF, #003078)',
    },
  }));

  const [isFileUploaded, setIsFileUploadedFlag] = useState(false);
  const [fileUploadText, setFileUploadText] = useState('Uploading Your Document...');
  const [fileSuccessFlag, setFileSuccessFlag] = useState(false);
  const navigate = useNavigate();

  const wrapperRef = useRef(null);

  const [fileList, setFileList] = useState([]);

  const onDragEnter = () => wrapperRef.current.classList.add('dragover');

  const onDragLeave = () => wrapperRef.current.classList.remove('dragover');

  const onDrop = () => wrapperRef.current.classList.remove('dragover');

  const onFileDrop = (e) => {

    const newFile = e.target.files[0];
    if (newFile) {
      const updatedList = [...fileList, newFile];
      setFileList(updatedList);
      handleUpload(newFile);
    }
  }

  const fileRemove = (file) => {
    const updatedList = [...fileList];
    updatedList.splice(fileList.indexOf(file), 1);
    setFileList(updatedList);
    props.onFileChange(updatedList);
  }

  const handleUpload = (file) => {
    setIsFileUploadedFlag(true);
    const formData = new FormData();
    formData.append("file", file);

    // Make API call to upload file
    fetch(props.url, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message.includes('empty')) {
          alert('File is empty, please try to upload file again.');
          setIsFileUploadedFlag(false);
        } else {
          setFileSuccessFlag(true);
          setFileUploadText('File Uploaded Successfully');
          setTimeout(() => {
            navigate(`/question-based-graph?queryFlag=true`);
          }, 500);

        }
        props.onFileChange(data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <>
      <div className={isFileUploaded ? 'overlay' : 'd-none'}>
        {!fileSuccessFlag ? <span className="loader"></span> : <span className='d-block'><CloudDoneOutlined style={{ fill: "#e00173" }} sx={{ fontSize: 150 }} /></span>}
        <span className={!fileSuccessFlag ? 'overlay-text' : 'overlay-text overlay-text-position'}>{fileUploadText}</span>
      </div>
      <div
        ref={wrapperRef}
        className="drop-file-input"
        onDragEnter={onDragEnter}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
      >
        <div className='upload-area'>
          <CloudUploadOutlined style={{ fill: "##014C90" }} sx={{ fontSize: 92 }} />
          <p style={{color: '#061648'}}>Drag and Drop</p>
        </div>
        <div className="drop-file-input__label">
          <p>To upload your datasets</p>
          <BrowseButton variant="contained" onClick={() => navigate('/dashboard')}>or Browse</BrowseButton>
        </div>
        <div className='supported-files'><span>Supported filetypes </span> <HelpOutline sx={{ fontSize: 12 }} /></div>
        <input type="file" value="" onChange={onFileDrop} />
      </div>
      {
        fileList.length > 0 ? (
          <div className="drop-file-preview" hidden="true">
            <p className="drop-file-preview__title">
              Ready to upload
            </p>
            {
              fileList.map((item, index) => (
                <div key={index} className="drop-file-preview__item">
                  <img src={ImageConfig[item.type.split('/')[1]] ||
                    ImageConfig['default']} alt="" />
                  <div className="drop-file-preview__item__info">
                    <p>{item.name}</p>
                    <p>{item.size}</p>
                  </div>
                  <span className="drop-file-preview__item__del"
                    onClick={() => fileRemove(item)}>
                    x
                  </span>
                </div>
              ))
            }
          </div>
        ) : null
      }
    </>
  );
};

FileUpload.propTypes = {
  onFileChange: PropTypes.func
}

export default FileUpload;
